module.exports = __webpack_public_path__ + "img/thank-you-evisa.e481fa1e.png";